<template>
  <div class="relative">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <div class="absolute bg-design4 mob-hidden">
      <img src="@/assets/images/bg-des/bgd4.svg" alt="bg-polygon" class="" />
    </div>
    <div class="absolute bg-design5 mob-hidden">
      <img
        src="@/assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <!-- <div class="absolute h-full lg:hidden md:hidden block w-full">
      <img
        src="@/assets/images/line/cg-line-1-1.svg"
        alt="bg"
        class="h-full w-full"
      />
    </div> -->
    <div
      class="lg:flex md:flex lg:gap-10 md:gap-10 items-center mb-5 md:mb-0 lg:mb-0 lg:px-12 md:px-10 px-4"
    >
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <iframe
          class="custborderradius smw-fill"
          width="100%"
          height="470"
          src="https://www.youtube.com/embed/d_-J6ob-bq4?si=zhrAfwiSbcs3hjb5"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <div
        class="lg:w-1/2 md:w-1/2 w-full z-10 relative lg:pt-0 md:pt-0"
        id="HealthcareDiv"
      >
        <div class="relative">
          <p class="subtitle fsize18 lh32px sm-fsize14">
            In India, the healthcare system depends on family caregivers to take
            care of medical adherence by patients and out-of-hospital care. The
            caregivers’ inability to access reliable information, respite care
            and emotional support creates trauma. Some opt to move out of the
            workforce to take up caregiving as a full-time role. Apart from the
            psycho-social and mental health implications, this impacts their
            ability to be financially independent and find meaning and purpose
            once the caregiving journey is over ( an enormous impact on
            low-income households). With rising medical expenditures and cost of
            daily living, it leaves them further impoverished.<br /><br />
            Family caregivers are one of the most unseen members of our
            community. Caregiver Saathi™️ aims to empower family caregivers by
            creating an ecosystem of well-being and healing for the primary
            caregiver for better patient outcomes.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handlecommunity() {
      this.$router.push({ name: "community" });
    },
  },
};
</script>
<style>
li {
  color: #000;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 3px;
}
.text-blo {
  color: #000;
  font-weight: 600;
  font-size: 15px;
}
.temp-h415 {
  height: 415px;
}
@media (max-width: 640px) {
  .sm-h-620px {
    height: 960px !important;
  }
  .smw-fill {
    width: -webkit-fill-available;
    height: 345px;
  }
}
</style>
